import { Disc3 } from "lucide-react";

/**
 * Ambient B-side backdrop for the About hero. Designed to live behind the
 * hero text as a full-bleed atmospheric layer — large gradient + oversized
 * vinyl disc, all edges fully blended into the surrounding navy.
 *
 * Caller should mount this inside an absolutely-positioned wrapper that
 * covers the hero section (and the disc auto-centers right of the text).
 */
export default function AboutHeroArt({ className = "" }) {
  return (
    <div
      className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}
      data-testid="about-hero-art"
      aria-hidden="true"
    >
      {/* Large violet gradient bloom — soft, full edges */}
      <div
        className="absolute"
        style={{
          // Oversized panel positioned off-center so it sits right of text
          top: "-20%",
          right: "-15%",
          width: "85%",
          height: "175%",
          backgroundImage:
            "radial-gradient(circle at 55% 50%, #ac62ea 0%, #7d3fbf 25%, #5d2d8f 50%, #312e81 70%, rgba(11,30,90,0) 85%)",
          opacity: 0.7,
          filter: "blur(8px)",
        }}
      />

      {/* Subtle diagonal weave on top of the bloom — also masked at edges */}
      <div
        className="absolute"
        style={{
          top: "-10%",
          right: "-10%",
          width: "75%",
          height: "150%",
          backgroundImage:
            "repeating-linear-gradient(135deg, rgba(255,255,255,0.05) 0 1px, transparent 1px 14px)",
          WebkitMaskImage:
            "radial-gradient(70% 70% at 55% 50%, #000 20%, rgba(0,0,0,0.6) 50%, rgba(0,0,0,0) 95%)",
          maskImage:
            "radial-gradient(70% 70% at 55% 50%, #000 20%, rgba(0,0,0,0.6) 50%, rgba(0,0,0,0) 95%)",
        }}
      />

      {/* Concentric vinyl watermark — much larger, sitting deep in the bloom */}
      <Disc3
        className="absolute -right-48 top-1/2 -translate-y-1/2 h-[44rem] w-[44rem] lg:h-[56rem] lg:w-[56rem] text-white/[0.09] transition-transform duration-700 ease-out group-hover:-translate-y-1/2 group-hover:rotate-[6deg] group-hover:scale-[1.03] group-hover:text-white/[0.13]"
        strokeWidth={1.0}
        aria-hidden
      />

      {/* Top-right eyebrow — anchored to the hero's max-w-7xl right edge */}
      <div className="absolute top-8 lg:top-12 inset-x-0 pointer-events-none">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex justify-end">
          <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.22em] font-medium text-white/65">
            Side A / Side B
          </div>
        </div>
      </div>
    </div>
  );
}
